import { RootState } from '@box/redux/types';

export const currentVersion = (state: RootState) =>
  state.app.version.currentVersion;
export const isVersionOutdated = (state: RootState) =>
  state.app.version.isVersionOutdated;
